const SlTag = 'sl-';
const SgdfTag = 'sgdf-';
//
// Emits a custom event with more convenient defaults.
//
export function overrideEvent(el, prevEvent) {
    if (prevEvent && prevEvent.type.includes(SlTag)) {
        prevEvent.preventDefault();
        prevEvent.stopPropagation();
        const newName = prevEvent.type.replace(SlTag, SgdfTag);
        if ('detail' in prevEvent) {
            const { bubbles, cancelable, composed, detail } = prevEvent;
            const event = new CustomEvent(newName, Object.assign({
                bubbles: true,
                cancelable: false,
                composed: true,
                detail: {},
            }, { bubbles, cancelable, composed, detail }));
            el.dispatchEvent(event);
        }
    }
}
//
// Emits a custom event with more convenient defaults.
//
export function emit(el, name, options) {
    const event = new CustomEvent(name, Object.assign({
        bubbles: true,
        cancelable: false,
        composed: true,
        detail: {},
    }, options));
    el.dispatchEvent(event);
    return event;
}
//# sourceMappingURL=event.js.map